// Cart Store
import { getField, updateField } from 'vuex-map-fields'

const fallbackRequiredFields = [
  'agb',
  'email',
  'gender',
  'firstname',
  'lastname',
]

const state = {
  addressBook: [],
  agb: false,
  comment: '',
  disclaimer: '',
  error: null,
  isGuest: 0,
  min_order_value: {},
  pending: false,
  pendingPurchase: false,
  quickCartVisible: false,
  isPaymentError: false,
  quickCartButton: '',
  cartRequiredFields: [],
  enable_paypal_paylater: false,
}

const getters = {
  isPending: ({ pending }) => pending,
  getField,
}

const actions = {
  createPaypalPayment({ commit }, payload, paylater = false) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      const target = paylater ? 'checkout.paypal_complete?paylater=true' : 'checkout.paypal_complete'
      this.api.items.createItem(target, payload)
        .then(({ data }) => {
          commit('SET_PENDING', false)
          if (data && data.url) {
            window.location.href = data.url
          }
          resolve()
        }).catch(err => {
          commit('SET_PENDING', false)
          commit('SET_ERROR', true)
          reject(err)
        })
    })
  },
  getCart({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items.getItem('carts.mine').then(({ data }) => {
        commit('SET_CART_REQUIRED_FIELDS', data.required_fields)
        commit('SET_ADDRESS_BOOK', data.address_book)
        commit('SET_IS_USER_GUEST', data.is_guest)
        commit('deliveryAddress/INIT_DELIVERY_ADDRESS', data, { root: true })
        commit('invoiceAddress/SET_USER_NEWSLETTER', data.has_newsletter, { root: true })
        commit('invoiceAddress/SET_HAS_USER_NEWSLETTER', data.has_newsletter, { root: true })
        commit('invoiceAddress/INIT_INVOICE_ADDRESS', data.invoice_address, { root: true })
        commit('formOptions/SET_FORM_OPTIONS', data.form_options, { root: true })
        commit('summary/SET_SUMMARY', data.cart.summary, { root: true })
        commit('vouchers/SET_VOUCHERS', data.vouchers, { root: true })
        commit('payment/INIT_ACTIVE_SERVICE', data.cart.payment, { root: true })
        commit('shipping/INIT_ACTIVE_SERVICE', data.cart.shipping, { root: true })
        commit('SET_COMMENT', data.cart.comment)
        commit('SET_DISCLAIMER', data.disclaimer)
        commit('SET_MIN_ORDER_VALUE', data.min_order_value)
        commit('SET_TOP_BUTTON', data.quickcart_button_top)
        commit('SET_PAYPAL_LATER', data.enable_paypal_paylater)
        if (data.cart.summary.props.delivery_date) {
          commit('shipping/SET_DELIVERY_DATE', data.cart.summary.props.delivery_date, { root: true })
        }
        commit('SET_PENDING', false)
        resolve()
      })
    })
  },
  updateComment({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
        .createItem('carts.mine.comment', { comment: payload })
        .then(_ => {
          commit('SET_COMMENT', payload)
          commit('SET_PENDING', false)
          resolve()
        })
    })
  },
  purchase({ state, commit }, newsletter) {
    return new Promise((resolve, reject) => {
      commit('SET_ERROR', false)
      if (state.min_order_value.reached && !state.pendingPurchase) {
        commit('SET_PENDING_PURCHASE', true)
        this.api.items
          .createItem('payments', { agb: state.agb, newsletter })
          .then(({ data }) => {
            if (data.result && data.redirect) {
              window.location.href = data.redirect
            } else if (data.redirect === '' || data.redirect === null) {
              commit('SET_PAYMENT_ERROR', true)
            } else {
              commit('SET_ERROR', true)
            }
            commit('SET_PENDING_PURCHASE', false)
            resolve()
          })
          .catch(err => {
            commit('SET_PENDING_PURCHASE', false)
            commit('SET_ERROR', true)
            reject(err)
          })
      } else {
        commit('SET_ERROR', true)
        resolve()
      }
    })
  },
  openQuickCart({ commit }) {
    commit('OPEN_QUICKCART')
  },
}

const mutations = {
  SET_PENDING: (state, payload) => {
    state.pending = payload
  },
  SET_PENDING_PURCHASE: (state, payload) => {
    state.pendingPurchase = payload
  },
  SET_ERROR: (state, payload) => {
    state.error = payload
    state.isPaymentError = false
  },
  OPEN_QUICKCART: state => {
    state.quickCartVisible = true
  },
  // SET_USER: (state, payload) => {
  //   state.user = payload
  // },
  SET_ADDRESS_BOOK: (state, payload) => {
    state.addressBook = payload
  },
  SET_IS_USER_GUEST: (state, payload) => {
    state.isGuest = payload
  },
  SET_COMMENT: (state, payload) => {
    state.comment = payload
  },
  SET_MIN_ORDER_VALUE: (state, payload) => {
    state.min_order_value = payload
  },
  SET_DISCLAIMER: (state, payload) => {
    state.disclaimer = payload
  },
  SET_PAYMENT_ERROR: (state, payload) => {
    state.isPaymentError = payload
  },
  SET_TOP_BUTTON: (state, payload) => {
    state.quickCartButton = payload
  },
  SET_PAYPAL_LATER: (state, payload) => {
    state.enable_paypal_paylater = payload
  },
  SET_CART_REQUIRED_FIELDS: (state, payload) => {
    state.cartRequiredFields = payload || fallbackRequiredFields
  },
  updateField,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
